import MainWrapper from "@components/pages/common/MainWrapper";
import useModalScrollFreeze from "@hooks/useModalScrollFreeze";
import { useState } from "react";
//import FilterBar from "@components/SearchManagement/FilterBar";
import { RAQ_PAGE_TYPE, STORAGE_LIKES } from "@components/utils/constants";
import useAppContext from "@hooks/useAppContext";
import DetailsPage from "@modules/detailsPage/DetailsPage";
import { RaQFormType } from "pages/things-to-do/[...slug]";
import { ITopNavigationResponse } from "../../../../types/commonResponses";
import { ILocationResponse } from "../../../../types/modelResponses";

interface ILocationPageViewProps {
  location: ILocationResponse;
  topNavigation: ITopNavigationResponse;
  raqFormType: RaQFormType;
}

function LocationPageView({
  location,
  topNavigation,
  raqFormType,
}: ILocationPageViewProps): JSX.Element {
  const appContext = useAppContext();
  const [viewAllActivities, openViewAllActivities] = useState(false);
  const [viewAllAccommodations, openViewAllAccommodations] = useState(false);

  useModalScrollFreeze([
    viewAllAccommodations,
    viewAllActivities,
    appContext?.showLoginModal,
  ]);

  return (
    <MainWrapper>
      <DetailsPage
        data={location}
        topNavigation={topNavigation}
        raqFormType={raqFormType}
        pageType={RAQ_PAGE_TYPE.PACKAGE}
        likesType={STORAGE_LIKES.locations}
        openViewAllActivities={openViewAllActivities}
        openViewAllAccommodations={openViewAllAccommodations}
        viewAllActivities={viewAllActivities}
        viewAllAccommodations={viewAllAccommodations}
      />
    </MainWrapper>
  );
}

export default LocationPageView;
